"use client";

import React, { useState } from "react";

import RecentActivityTable from "../RecentActivityTable/RecentActivityTable";
import DashboardBanner from "@components/Banner/DashboardBanner";
import { Card, CardContent, CardHeader } from "@tracify/ui/card";

export function RecentActivitySettings() {
  return (
    <>
      <div className="lg:sticky lg:top-0 bg-background py-4 z-navbar">
        <DashboardBanner />
        <h2 className="h2">Activity</h2>
      </div>
      <div>
        <Card className="min-h-[calc(100vh-124px)]">
          <CardHeader>
            <p>
              Monitor recent incoming events to confirm your tracking is working
              correctly.
            </p>
          </CardHeader>
          <CardContent>
            <RecentActivityTable />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
